import { showPopup } from "./uiActions"
import { saveAs } from 'file-saver'

export function getProjects() {

    return fetch(`${process.env.REACT_APP_BACK_URL}/databasefunctions/dbprojects`, {
        method: 'GET',
        headers: {
            'accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
        }
    }).then((resp) => {
        if (resp.status !== 200) {
            console.error(resp)
        } else {
            return resp.json()
        }
    })
}

export function saveProject(project) {

    return fetch(`${process.env.REACT_APP_BACK_URL}/databasefunctions/saveproject`, {
        method: 'POST',
        headers: {
            'accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
        },
        body: JSON.stringify(project)
    }).then((resp) => {
        if (resp.status !== 200) {
            return resp.text().then(text => {
                throw new Error(text)
            })
        }
        return resp.text()
    })
}

export function deleteProject(projectId) {
    return fetch(`${process.env.REACT_APP_BACK_URL}/databasefunctions/deleteproject/${projectId}`, {
        method: 'DELETE',
        headers: {
            'accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
        },
        body: ''
    }).then((resp) => {
        if (resp.status !== 200) {
            return resp.text().then(text => {
                throw new Error(text)
            })
        }
        return resp.text()
    })
}

export function moveJobToProject(jobId, projectId) {
    return function (dispatch) {
        return fetch(`${process.env.REACT_APP_BACK_URL}/databasefunctions/movejobtoproject`, {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
            body: JSON.stringify({ JobId: jobId, ProjectId: projectId })
        }).then((resp) => {
            if (resp.status !== 200) {
                return resp.text().then(text => { throw new Error(text) })
            }
            dispatch(resetJobs())
            dispatch(getDbJobsSiteWide(-1))
            return resp.text()
        })
    }
}


export function deleteDbJob(jobId) {
    return function (dispatch) {
        return fetch(`${process.env.REACT_APP_BACK_URL}/databasefunctions/deletedbjob/${jobId}`, {
            method: 'DELETE',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            }
        })
    }
}

export function getDbJobsSiteWide(jobTypeId) {
    return function (dispatch) {
        fetch(`${process.env.REACT_APP_BACK_URL}/databasefunctions/dbjobs?jobTypeId=${jobTypeId}`, {
            method: 'GET',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            }
        }).then((resp) => {
            if (resp.status !== 200) {
                console.error(resp)
            } else {
                return resp.json()
            }
        }).then((json) => {
            let jobsResp = json["jobs"]
            return dispatch(selfServiceDatabaseJobs(jobsResp))
        })
    }
}

export function getDbJobHistorySiteWide(jobTypeId) {
    return function (dispatch) {
        return fetch(`${process.env.REACT_APP_BACK_URL}/databasefunctions/dbjobhistory?jobTypeId=${jobTypeId}`, {
            method: 'GET',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            }
        }).then((resp) => {
            if (resp.status !== 200) {
                console.error(resp)
            } else {
                return resp.json()
            }
        }).then((json) => {
            let jobsResp = json["history"]
            return dispatch(selfServiceDatabaseJobHistories(jobsResp))
        })
    }
}

export function startDbJob(jobId) {
    return function (dispatch) {
        fetch(`${process.env.REACT_APP_BACK_URL}/databasefunctions/startjob?jobID=${jobId}`, {
            method: 'GET',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            }
        }).then((resp) => {
            if (resp.status !== 200) {
                console.error(resp)
            } else {
                return resp.json()
            }
        }).then((json) => {
            if (json === undefined) {
                return dispatch(showPopup("confirmationPopup", "Failed To Start Job, Most Likely Due To Current Job Already Running Against Database", false))
            } else {
                dispatch(showPopup("confirmationPopup", "Job Start Has Been Sent to Queue", true))
                return dispatch(startDatabaseJob(json))
            }
        })
    }
}

export function getDataSources(id) {
    return function (dispatch) {
        return fetch(`${process.env.REACT_APP_BACK_URL}/databasefunctions/datatools2/datasources/${id}`, {
            method: 'GET',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            }
        })
    }
}

export function getTransformData(id) {
    return function (dispatch) {
        return fetch(`${process.env.REACT_APP_BACK_URL}/databasefunctions/datatools2/transformdata/${id}`, {
            method: 'GET',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            }
        })
    }
}

export function saveDataToolsJob(jobTypeId, jobData, jobId, jobName, jobDescription, projectId) {
    return function (dispatch) {
        fetch(`${process.env.REACT_APP_BACK_URL}/databasefunctions/datatools2/saveDBjob`, {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
            body: JSON.stringify({
                JobId: jobId,
                JobType: jobTypeId,
                JobData: jobData,
                JobName: jobName,
                JobDescription: jobDescription,
                ProjectId: projectId
            })
        }).then((resp) => {
            if (resp.status !== 200) {
                throw new Error(resp)
            } else {
                return resp.json()
            }
        }).then((json) => {
            dispatch(resetJobs())
            dispatch(getDbJobsSiteWide(-1))
            dispatch(getDbJobHistorySiteWide(-1))
            return dispatch(showPopup("confirmationPopup", "Database Job Task List Saved"))
        })
    }
}

export function dataToolsGetDimensions(databaseId, dataSourceSystemName) {
    return function (dispatch) {
        return fetch(`${process.env.REACT_APP_BACK_URL}/databasefunctions/datatools2/getDimensions`, {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
            body: JSON.stringify({
                DatabaseId: databaseId,
                DataSourceSystemName: dataSourceSystemName
            })
        })
    }
}

export function dataToolsGetDimensionMembers(databaseId, dataSourceSystemName, dimensionSystemName, alreadyLoaded, searchTerm) {
    return function (dispatch) {
        return fetch(`${process.env.REACT_APP_BACK_URL}/databasefunctions/datatools2/getDimensionMembers`, {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
            body: JSON.stringify({
                DatabaseId: databaseId,
                DataSourceSystemName: dataSourceSystemName,
                DimensionSystemName: dimensionSystemName,
                SearchTerm: searchTerm,
                AlreadyLoaded: alreadyLoaded
            })
        })
    }
}

export function dataToolsGetMeasureAggregations(databaseId, dataSourceSystemName) {
    return function (dispatch) {
        return fetch(`${process.env.REACT_APP_BACK_URL}/databasefunctions/datatools2/getMeasureAggregationTable`, {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
            body: JSON.stringify({
                DatabaseId: databaseId,
                DataSourceSystemName: dataSourceSystemName
            })
        })
    }
}

export function readColumnsFromZipEntry(fileName, fileUrl, fileContainerName, fileBlobName, selectedFileFromZip) {
    return function (dispatch) {
        return fetch(`${process.env.REACT_APP_BACK_URL}/databasefunctions/datatools2/readColumnsFromZipEntry`, {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
            body: JSON.stringify({
                name: fileName,
                url: fileUrl,
                containerName: fileContainerName,
                blobName: fileBlobName,
                selectedFileName: selectedFileFromZip
            })
        })
    }
}

/**
 * getPreviewData
 * * Grabs the first 500 rows of data from the file information passed through
 * @param {string} zipFileId - ZIP File GUID
 * @param {int} textQualifier - Text qualifier value
 * @param {string[]} sourceFiles - Source file names
 * @param {int} textDelimiter - Delimiter value
 * @param {string} customDelimiter - Custom delimiter not part of the hardcoded values
 * @param {string[]} selectedExcelTables - Excel tables selected
*/
export function getPreviewData(zipFileId, textQualifier, sourceFiles, textDelimiter, customDelimiter, selectedExcelTables) {
    return function (dispatch) {
        return fetch(`${process.env.REACT_APP_BACK_URL}/databasefunctions/datatools2/getPreviewData`, {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
            body: JSON.stringify({
                zipFileId: zipFileId,
                textQualifier: textQualifier,
                sourceFiles: sourceFiles,
                textDelimiter: textDelimiter,
                customDelimiter: customDelimiter,
                selectedExcelTables: selectedExcelTables
            })
        })
    }
}

export function readTablesFromExcel(fileName, fileUrl, fileContainerName, fileBlobName, selectedFileFromZip) {
    return function (dispatch) {
        let bodyArray = [{
            name: fileName,
            url: fileUrl,
            containerName: fileContainerName,
            blobName: fileBlobName,
            selectedFileName: selectedFileFromZip
        }]

        return fetch(`${process.env.REACT_APP_BACK_URL}/databasefunctions/datatools2/readTablesFromExcel`, {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
            body: JSON.stringify(bodyArray)
        })
    }
}

export function readTablesFromExcelFiles(allExcelFiles) {
    return function (dispatch) {
        return fetch(`${process.env.REACT_APP_BACK_URL}/databasefunctions/datatools2/readTablesFromExcel`, {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
            body: JSON.stringify(allExcelFiles)
        })
    }
}

/**
 * Calls API end point to compare dimensions between two data sources 
 * @param {int} databaseId - Selected Target Database ID
 * @param {string} dataSourceSystemName - Data Source System Name of the Target Database
 * @param {int} originDatabaseId - Selected Origin Database ID
 * @param {string} originDataSourceSystemName - Data Source System Name of the Origin Database
 */
export function dataToolsGetDimensionsComparison(databaseId, dataSourceSystemName, originDatabaseId, originDataSourceSystemName) {
    return function (dispatch) {
        return fetch(`${process.env.REACT_APP_BACK_URL}/databasefunctions/datatools2/getDimensionsComparison`, {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
            body: JSON.stringify({
                DatabaseId: databaseId,
                DataSourceSystemName: dataSourceSystemName,
                OriginDatabaseId: originDatabaseId,
                OriginDataSourceSystemName: originDataSourceSystemName
            })
        })
    }
}

/**
 * Calls API end point to compare dimensions between two data sources 
 * @param {string[]} files - Blobs To Remove
 */
export function dataToolsDeleteBlobsFromUnfinishedJob(files) {
    return function (dispatch) {
        return fetch(`${process.env.REACT_APP_BACK_URL}/databasefunctions/datatools2/removeUploadedBlobsFromUnfinished`, {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
            body: JSON.stringify(files)
        })
    }
}

/**
 * Calls API end point to get all Database Job Files
 */
export function getDatabaseJobFiles() {
    return function (dispatch) {
        fetch(`${process.env.REACT_APP_BACK_URL}/databasefunctions/dbjobfiles`, {
            method: 'GET',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            }
        }).then((resp) => {
            if (resp.status !== 200) {
                console.error(resp)
            } else {
                return resp.json()
            }
        }).then((json) => {
            let jobsResp = json["files"]
            return dispatch(selfServiceDatabaseJobFiles(jobsResp))
        })
    }
}

/**
 * Calls API end point to save the database job file
 * @param {int} id - ID of the job file (if we are saving, make 0 or -1 to create new)
 * @param {Object} fileData - Blob data for the file
 * @param {Array} teamIds - Team ID int array
 * @param {string} fileDescription - Description of the file
 * @param {string[]} snippets - File Snippets
 */
export function saveDatabaseJobFile(id, fileData, fileDescription, snippets, projectId) {
    return function (dispatch) {
        return fetch(`${process.env.REACT_APP_BACK_URL}/databasefunctions/savedbjobfile`, {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
            body: JSON.stringify({
                ID: id,
                FileDescription: fileDescription,
                FileData: fileData,
                Snippets: snippets,
                ProjectId: projectId
            })
        })
    }
}

/**
 * deleteDatabaseJobFile
 * * Calls API end point to save the database job file
 * @param {int} jobFileId - ID of the job file we are deleting
 */
export function deleteDatabaseJobFile(jobFileId) {
    return function (dispatch) {
        return fetch(`${process.env.REACT_APP_BACK_URL}/databasefunctions/deletedbjobfile/${jobFileId}`, {
            method: 'DELETE',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            }
        })
    }
}

/**
 * purgePreviosJobFiles
 * * Calls API end point to purge the files from storage from a job, called when uploading new files in edit mode
 * @param {int} jobFileId - ID of the job file we are deleting
 */
export function purgePreviosJobFiles(jobFileId) {
    return function (dispatch) {
        return fetch(`${process.env.REACT_APP_BACK_URL}/databasefunctions/purgePreviousFiles?jobFileId=${jobFileId}`, {
            method: 'DELETE',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            }
        })
    }
}
export function downloadDatabaseJobFile(jobFileId, fileName) {
    return function (dispatch) {
        dispatch(showPopup("loadingPopup", "Download Starting Now..."))
        fetch(`${process.env.REACT_APP_BACK_URL}/databasefunctions/datatools2/${jobFileId}/downloadfile`, {
            method: 'GET',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
        }).then((resp) => {
            if (resp.status !== 200) {
                throw new Error()
            } else {
                return resp.json()
            }
        }).then(fileUrl => {

            // Trigger native browser download
            const link = document.createElement('a');
            link.href = fileUrl;
            link.download = fileName || '';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            return dispatch(showPopup("confirmationPopup", "Download Started"))
        })
            .catch((ex) => {
                return dispatch(showPopup("confirmationPopup", "Download file Failed", false))
            })
    }
}
export function createNewWizardFile(data) {
    return function (dispatch) {
        return fetch(`${process.env.REACT_APP_BACK_URL}/databasefunctions/createNewWizardFile`, {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
            body: JSON.stringify(data)
        })
    }
}

export function openEditNewWizardFile(fileId) {
    return function (dispatch) {
        return fetch(`${process.env.REACT_APP_BACK_URL}/databasefunctions/editWizardFile/${fileId}`, {
            method: 'GET',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            }
        })
    }
}

export function editWizardFile(data) {
    return function (dispatch) {
        return fetch(`${process.env.REACT_APP_BACK_URL}/databasefunctions/editWizardFile`, {
            method: 'PATCH',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
            body: JSON.stringify(data)
        })
    }
}

export function resetJobs() {
    return { type: 'SELF_SERVICE_INDEX' }
}

export function startDatabaseJob(jobId) {
    return { type: 'SELF_SERVICE_JOB_START', jobID: jobId }
}

export function sendDatabaseJobProgress(jobId, progress, total) {
    return { type: 'SELF_SERVICE_JOB_PROGRESS', jobID: jobId, progress: progress, total: total }
}

export function selfServiceDatabaseJobs(payload) {
    return { type: 'SELF_SERVICE_DATABASE_JOBS', payload: payload }
}

export function selfServiceDatabaseJobHistories(payload) {
    return { type: 'SELF_SERVICE_DATABASE_JOB_HISTORIES', payload: payload }
}

export function selfServiceDatabaseJobFiles(payload) {
    return { type: 'SELF_SERVICE_DATABASE_JOB_FILES', payload: payload }
}

export function selfServiceChangeFilesPage(pageNumber) {
    return { type: 'SELF_SERVICE_JOB_FILES_PAGE_CHANGE', pageNumber: pageNumber }
}

export function selfServiceChangeJobsPage(pageNumber) {
    return { type: 'SELF_SERVICE_JOB_PAGE_CHANGE', pageNumber: pageNumber }
}

export function selfServiceChangeHistoriesPage(pageNumber) {
    return { type: 'SELF_SERVICE_JOB_HISTORIES_CHANGE', pageNumber: pageNumber }
}
